import {
  AttributeDefinition,
  CertificationAndLicense,
  Company,
  CompanyRole,
  MultiSelectOption,
  Team,
} from '@dispatch/shared/types';
import { dispatchClient } from '../clients';

const APIM_SERVICE_COMPANIES_URL = 'dispatch/resourceService/company';

export async function getCompanyId(): Promise<string | undefined> {
  try {
    const response = await dispatchClient.get<Company>(
      APIM_SERVICE_COMPANIES_URL
    );
    const company = response.data;
    if (response.status === 200 && company) {
      return company.integrationGUID;
    }
  } catch (e) {
    throw new Error('Error fetching companies to get id');
  }
  return undefined;
}

export async function getCompanyRoles(): Promise<CompanyRole[] | undefined> {
  const companyId = await getCompanyId();
  if (!companyId) throw new Error();
  try {
    const response = await dispatchClient.get<CompanyRole[]>(
      APIM_SERVICE_COMPANIES_URL + '/roles'
    );

    const apiCompanyRoles: CompanyRole[] = response?.data;

    if (response.status === 200 && apiCompanyRoles) {
      return apiCompanyRoles;
    }
  } catch (e) {
    throw new Error('Error fetching company roles');
  }
  return undefined;
}

export async function getCompanyAttributes(): Promise<
  AttributeDefinition[] | undefined
> {
  const companyId = await getCompanyId();
  if (!companyId) throw new Error();
  try {
    const response = await dispatchClient.get<AttributeDefinition[]>(
      APIM_SERVICE_COMPANIES_URL + '/attributes'
    );

    const apiCompanyAttributes: AttributeDefinition[] = response?.data;

    if (response.status === 200 && apiCompanyAttributes) {
      return apiCompanyAttributes;
    }
  } catch (e) {
    throw new Error('Error fetching company attributes');
  }
  return undefined;
}

//TODO: This mapping needs to get moved to the hook
// we should not be mapping from the service
export async function getCompanyTeamOptions(): Promise<
  MultiSelectOption[] | undefined
> {
  const companyId = await getCompanyId();
  if (!companyId) throw new Error();
  try {
    const response = await dispatchClient.get<Team[]>(
      APIM_SERVICE_COMPANIES_URL + '/teams'
    );

    const apiCompanyTeams: Team[] = response?.data;

    const teamOptions: MultiSelectOption[] = apiCompanyTeams.map(
      (team: Team) => {
        return {
          title: team.name,
          value: team.integrationGUID,
        };
      }
    );

    if (response.status === 200 && teamOptions) {
      return teamOptions;
    }
  } catch (e) {
    throw new Error('Error fetching company attributes');
  }
  return undefined;
}

export async function getCompanyTeams(): Promise<Team[] | undefined> {
  const companyId = await getCompanyId();
  if (!companyId) throw new Error();
  try {
    const response = await dispatchClient.get<Team[]>(
      APIM_SERVICE_COMPANIES_URL + '/teams'
    );

    const apiCompanyTeams: Team[] = response?.data;

    if (response.status === 200 && apiCompanyTeams) {
      return apiCompanyTeams;
    }
  } catch (e) {
    throw new Error('Error fetching company attributes');
  }
  return undefined;
}

export async function getCompanyCertsAndLicense(companyId: string) {
  if (!companyId) return;
  return dispatchClient.get<CertificationAndLicense[]>(
    APIM_SERVICE_COMPANIES_URL + '/certs'
  );
}

export async function getCompanyEventCategories(): Promise<
  string[] | undefined
> {
  try {
    const response = await dispatchClient.get<string[]>(
      APIM_SERVICE_COMPANIES_URL + '/eventcategories'
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (e) {
    throw new Error('Error fetching company event categories');
  }
  return undefined;
}
